"use strict";

module.exports.sector_activity = [{
  label: 'Agriculture',
  value: 'Agriculture'
}, {
  label: 'Agroalimentaire',
  value: 'Agroalimentaire'
}, {
  label: 'Assurance',
  value: 'Assurance'
}, {
  label: 'Automobile',
  value: 'Automobile'
}, {
  label: 'Banque',
  value: 'Banque'
}, {
  label: 'Bois',
  value: 'Bois'
}, {
  label: 'Papier',
  value: 'Papier'
}, {
  label: 'Cartonnerie',
  value: 'Cartonnerie'
}, {
  label: 'Plastique',
  value: 'Plastique'
}, {
  label: 'Imprimerie',
  value: 'Imprimerie'
}, {
  label: 'Matériaux de construction',
  value: 'Matériaux de construction'
}, {
  label: 'BTP',
  value: 'BTP'
}, {
  label: 'Chimie / Parachimie',
  value: 'Chimie / Parachimie'
}, {
  label: 'Commerce / Négoce / Distribution',
  value: 'Commerce / Négoce / Distribution'
}, {
  label: 'Édition / Communication / Multimédia',
  value: 'Édition / Communication / Multimédia'
}, {
  label: 'Électronique / Électricité',
  value: 'Électronique / Électricité'
}, {
  label: 'Études et conseils',
  value: 'Études et conseils'
}, {
  label: 'Industrie pharmaceutique',
  value: 'Industrie pharmaceutique'
}, {
  label: 'Informatique',
  value: 'Informatique'
}, {
  label: 'Pétrole',
  value: 'Pétrole'
}, {
  label: 'Energie',
  value: 'Energie'
}, {
  label: 'Réseaux',
  value: 'Réseaux'
}, {
  label: 'Machines et équipements',
  value: 'Machines et équipements'
}, {
  label: 'Métallurgie',
  value: 'Métallurgie'
}, {
  label: 'Services aux entreprises',
  value: 'Services aux entreprises'
}, {
  label: 'Services sociaux',
  value: 'Services sociaux'
}, {
  label: 'Services médicaux',
  value: 'Services médicaux'
}, {
  label: 'Services médico – sociaux',
  value: 'Services médico – sociaux'
}, {
  label: 'Services à la personne',
  value: 'Services à la personne'
}, {
  label: 'Textile / Habillement / Chaussure',
  value: 'Textile / Habillement / Chaussure'
}, {
  label: 'Transports / Logistique',
  value: 'Transports / Logistique'
}];

// Liste des services

module.exports.service_options = [{
  label: "Achats",
  value: "achat"
}, {
  label: "Administratif",
  value: "administratif"
}, {
  label: "Artisans",
  value: "artisan"
}, {
  label: "Secrétariat",
  value: "secretariat"
}, {
  label: "Chantier",
  value: "chantier"
}, {
  label: "Commercial / Ventes",
  value: "vente"
}, {
  label: "Communication / Documentation",
  value: "communication"
}, {
  label: "Entretien / Maintenance",
  value: "entretien"
}, {
  label: "Enseignement",
  value: "enseignement"
}, {
  label: "Finances / Gestion / Comptabilité",
  value: "comptabilite"
}, {
  label: "Informatique",
  value: "informatique"
}, {
  label: "Ingenierie",
  value: "ingenierie"
}, {
  label: "Juridique",
  value: "juridique"
}, {
  label: "Logistique",
  value: "logistique"
}, {
  label: "Marketing",
  value: "marketing"
}, {
  label: "Méthodes",
  value: "methode"
}, {
  label: "Production",
  value: "production"
}, {
  label: "Qualité / Sécurité / Environnement",
  value: "qualite_securite"
}, {
  label: "Recherche / Études et laboratoire",
  value: "recherche_labo"
}, {
  label: "Relations clients / Service après-vente",
  value: "sav"
}, {
  label: "Ressources humaines",
  value: "rh"
}, {
  label: "Services généraux",
  value: "services_generaux"
}];

// Liste des fonctions par services

module.exports.achat_options = [{
  label: 'Directeur des achats / Responsable achats',
  value: 'Directeur des achats / Responsable achats'
}, {
  label: 'Acheteur',
  value: 'Acheteur'
}, {
  label: 'Assistant achats',
  value: 'Assistant achats'
}, {
  label: 'Secrétariat',
  value: 'Secrétariat'
}];
module.exports.administratif_options = [{
  label: 'Responsable administratif',
  value: 'Responsable administratif'
}, {
  label: 'Technicien de gestion administrative',
  value: 'Technicien de gestion administrative'
}, {
  label: 'Agent administratif',
  value: 'Agent administratif'
}];
module.exports.artisan_options = [{
  label: 'Boucher',
  value: 'Boucher'
}, {
  label: 'Boulanger',
  value: 'Boulanger'
}, {
  label: 'Charcutier',
  value: 'Charcutier'
}, {
  label: 'Coiffeur',
  value: 'Coiffeur'
}, {
  label: 'Esthétique',
  value: 'Esthétique'
}, {
  label: 'Peintre',
  value: 'Peintre'
}, {
  label: 'Mécanicien',
  value: 'Mécanicien'
}, {
  label: 'Plombier',
  value: 'Plombier'
}, {
  label: 'Electricien ',
  value: 'Electricien '
}, {
  label: 'Instruments de musique ',
  value: 'Instruments de musique '
}];
module.exports.secretariat_options = [{
  label: 'Assistant de direction générale',
  value: 'Assistant de direction générale'
}, {
  label: 'Secrétaire de direction',
  value: 'Secrétaire de direction'
}, {
  label: 'Secrétaire',
  value: 'Secrétaire'
}];
module.exports.chantier_options = [{
  label: 'Ingénieur',
  value: 'Ingénieur'
}, {
  label: 'Qualité',
  value: 'Qualité'
}, {
  label: 'Ouvrier',
  value: 'Ouvrier'
}, {
  label: 'Technicien',
  value: 'Technicien'
}, {
  label: 'Conducteur de chantiers',
  value: 'Conducteur de chantiers'
}, {
  label: 'Contacteur d’engins',
  value: 'Contacteur d’engins'
}];
module.exports.vente_options = [{
  label: 'Commercial',
  value: 'Commercial'
}, {
  label: 'Caisse',
  value: 'Caisse'
}, {
  label: 'Merchandiseur / Category manager',
  value: 'Merchandiseur / Category manager'
}, {
  label: 'Assistant',
  value: 'Assistant'
}];
module.exports.communication_options = [{
  label: 'Directeur de la communication',
  value: 'Directeur de la communication'
}, {
  label: 'Chargé de communication / Assistant communication',
  value: 'Chargé de communication / Assistant communication'
}, {
  label: 'Documentaliste',
  value: 'Documentaliste'
}];
module.exports.entretien_options = [{
  label: 'Agent de maintenance',
  value: 'Agent de maintenance'
}, {
  label: 'Agent d’entretien',
  value: 'Agent d’entretien'
}, {
  label: 'Responsable de groupe',
  value: 'Responsable de groupe'
}];
module.exports.enseignement_options = [{
  label: 'Professeur',
  value: 'Professeur'
}, {
  label: 'Assistant professeur',
  value: 'Assistant professeur'
}, {
  label: 'Proviseur',
  value: 'Proviseur'
}];
module.exports.comptabilite_options = [{
  label: 'Responsable administratif et financier',
  value: 'Responsable administratif et financier'
}, {
  label: 'Comptable',
  value: 'Comptable'
}, {
  label: 'Banque',
  value: 'Banque'
}, {
  label: 'Contrôle de gestion',
  value: 'Contrôle de gestion'
}, {
  label: 'Analyste financier',
  value: 'Analyste financier'
}];
module.exports.informatique_options = [{
  label: 'Web / Multimédia',
  value: 'Web / Multimédia'
}, {
  label: 'Sécurité informatique',
  value: 'Sécurité informatique'
}, {
  label: 'Administrateur systèmes et / ou réseaux',
  value: 'Administrateur systèmes et / ou réseaux'
}, {
  label: 'Développeur',
  value: 'Développeur'
}, {
  label: 'Intelligence artificielle',
  value: 'Intelligence artificielle'
}, {
  label: 'Data',
  value: 'Data'
}, {
  label: 'Spécialiste CRM',
  value: 'Spécialiste CRM'
}];
module.exports.ingenierie_options = [{
  label: 'Architecte',
  value: 'Architecte'
}, {
  label: 'Ingénieur',
  value: 'Ingénieur'
}, {
  label: 'Technicien',
  value: 'Technicien'
}];
module.exports.juridique_options = [{
  label: 'Juriste d’entreprise',
  value: 'Juriste d’entreprise'
}, {
  label: 'Assistant juridique',
  value: 'Assistant juridique'
}, {
  label: 'Avocat',
  value: 'Avocat'
}, {
  label: 'Juge',
  value: 'Juge'
}];
module.exports.logistique_options = [{
  label: 'Réceptionnaire / Expéditionnaire',
  value: 'Réceptionnaire / Expéditionnaire'
}, {
  label: 'Responsable logistique / Supply chain',
  value: 'Responsable logistique / Supply chain'
}, {
  label: 'Manutentionnaire',
  value: 'Manutentionnaire'
}, {
  label: 'Cariste',
  value: 'Cariste'
}, {
  label: 'Routiers',
  value: 'Routiers'
}, {
  label: 'Conducteurs de véhicules de livraison',
  value: 'Conducteurs de véhicules de livraison'
}];
module.exports.marketing_options = [{
  label: 'Graphiste / Infographiste',
  value: 'Graphiste / Infographiste'
}, {
  label: 'Directeur marketing / Responsable marketing',
  value: 'Directeur marketing / Responsable marketing'
}, {
  label: 'Chef de produits',
  value: 'Chef de produits'
}, {
  label: '',
  value: ''
}];
module.exports.methode_options = [{
  label: 'Directeur industriel',
  value: 'Directeur industriel'
}, {
  label: 'Responsable méthodes / Ingénieur méthodes',
  value: 'Responsable méthodes / Ingénieur méthodes'
}, {
  label: 'Technicien méthodes',
  value: 'Technicien méthodes'
}];
module.exports.production_options = [{
  label: 'Fonction direction usine',
  value: 'Fonction direction usine'
}, {
  label: 'Directeur technique',
  value: 'Directeur technique'
}, {
  label: 'Directeur de production / Responsable de production',
  value: 'Directeur de production / Responsable de production'
}, {
  label: 'Technicien production',
  value: 'Technicien production'
}, {
  label: 'Ouvrier production',
  value: 'Ouvrier production'
}, {
  label: 'Ferronnier',
  value: 'Ferronnier'
}];
module.exports.qualite_securite_options = [{
  label: 'Animateur sécurité / Coordinateur sécurité',
  value: 'Animateur sécurité / Coordinateur sécurité'
}, {
  label: 'Responsable qualité',
  value: 'Responsable qualité'
}, {
  label: 'Agent de sécurité',
  value: 'Agent de sécurité'
}, {
  label: 'Responsable hygiène sécurité environnement (HSE)',
  value: 'Responsable hygiène sécurité environnement (HSE)'
}];
module.exports.recherche_labo_options = [{
  label: 'Directeur recherche et développement',
  value: 'Directeur recherche et développement'
}, {
  label: 'Responsable recherche / Responsable développement',
  value: 'Responsable recherche / Responsable développement'
}, {
  label: 'Responsable bureau d’études',
  value: 'Responsable bureau d’études'
}];
module.exports.sav_options = [{
  label: 'Chargé de recouvrement / Crédit manager',
  value: 'Chargé de recouvrement / Crédit manager'
}, {
  label: 'Service clients / service après-vente',
  value: 'Service clients / service après-vente'
}, {
  label: 'Administration des ventes',
  value: 'Administration des ventes'
}];
module.exports.rh_options = [{
  label: ' Responsable ressources humaines',
  value: ' Responsable ressources humaines'
}, {
  label: 'Administration du personnel',
  value: 'Administration du personnel'
}, {
  label: 'Paie',
  value: 'Paie'
}, {
  label: 'Recrutement ',
  value: 'Recrutement '
}, {
  label: 'Psychologue du travail',
  value: 'Psychologue du travail'
}];
module.exports.services_generaux_options = [{
  label: 'Hôte / Hôtesse d’accueil / Standardiste',
  value: 'Hôte / Hôtesse d’accueil / Standardiste'
}, {
  label: 'Agent des services généraux',
  value: 'Agent des services généraux'
}];
module.exports.support_options = [{
  value: "Accueil",
  label: "Accueil"
}, {
  value: "Entretien préalable",
  label: "Entretien préalable"
}, {
  value: "Accompagnement en cours",
  label: "Accompagnement en cours"
}, {
  value: "Objectif atteint",
  label: "Objectif atteint"
}, {
  value: "Pause",
  label: "Pause"
}, {
  value: "Arrêt",
  label: "Abandon"
}, {
  value: "Terminé",
  label: "Terminé"
}, {
  value: "Construction de projet professionnel",
  label: "(Ancien statut) Construction de projet professionnel"
}, {
  value: "Création d'entreprise",
  label: "(Ancien statut) Création d'entreprise"
}, {
  value: "En emploi",
  label: "(Ancien statut) En emploi"
}, {
  value: "En formation",
  label: "(Ancien statut) En formation"
}, {
  value: "En stage",
  label: "(Ancien statut) En stage"
}, {
  value: "Maintien en emploi",
  label: "(Ancien statut) Maintien en emploi"
}, {
  value: "Recherche d'alternance",
  label: "(Ancien statut) Recherche d'alternance"
}, {
  value: "Recherche d'emploi",
  label: "(Ancien statut) Recherche d'emploi"
}, {
  value: "Recherche de formation",
  label: "(Ancien statut) Recherche de formation"
}, {
  value: "Recherche de stage",
  label: "(Ancien statut) Recherche de stage"
}, {
  value: "Reconversion",
  label: "(Ancien statut) Reconversion"
}, {
  value: "Terminé",
  label: "(Ancien statut)Terminé avec succès"
}];
module.exports.monitoring_type_options = [{
  value: 'Préparation à l\'emploi',
  label: 'Préparation à l\'emploi'
}, {
  value: 'Boarding',
  label: 'Boarding'
}, {
  value: 'Sécurisation',
  label: 'Sécurisation'
}, {
  value: 'Maintien de l\'emploi',
  label: 'Maintien de l\'emploi'
}, {
  value: 'Recherche de formation',
  label: 'Recherche de formation'
}, {
  value: 'Passerelle bénévolat',
  label: 'Passerelle bénévolat'
}, {
  value: 'Découverte métier(s)',
  label: 'Découverte métier(s)'
}, {
  value: 'Reconversion',
  label: 'Reconversion'
}, {
  value: 'Conseil sur projet professionnel',
  label: 'Conseil sur projet professionnel'
}, {
  value: 'Pair aidance',
  label: 'Pair aidance'
}, {
  value: 'Réorientation externe',
  label: 'Réorientation externe'
}, {
  value: 'Intensif',
  label: '(Ancien statut) Intensif'
}, {
  value: 'Non intensif',
  label: '(Ancien statut) Non intensif'
}, {
  value: 'Filière CV',
  label: '(Ancien statut) Filière CV'
}];
module.exports.options_dispositif = [{
  value: 'Fondation AA',
  label: 'Fondation AA'
}, {
  value: 'Fonds Lyon',
  label: 'Fonds Lyon'
}, {
  value: 'PEA69',
  label: 'PEA69'
}, {
  value: 'Filière employeur',
  label: 'Filière employeur'
}, {
  value: 'Suivi Aspiejob',
  label: '(Ancien statut) Suivi Aspiejob'
}, {
  value: 'Suivi Aspiejob_Conseil',
  label: '(Ancien statut) Suivi Aspiejob Conseil'
}, {
  value: 'Suivi DEA',
  label: '(Ancien statut) Suivi DEA'
}, {
  value: 'Contrat à impact',
  label: '(Ancien statut) Contrat à impact'
}, {
  value: 'Autre dispositif',
  label: '(Ancien statut) Autre dispositif'
}];
module.exports.account_status_options = [{
  label: "En attente dossier",
  value: "En attente dossier"
}, {
  label: "En file d'attente",
  value: "En file d'attente"
}, {
  label: "Accepté",
  value: "accepted"
}, {
  label: "Réorienté",
  value: "Réorienté"
}, {
  label: "Non accepté",
  value: "refused"
}, {
  label: "Désinscrit",
  value: "unsubscribe"
}, {
  label: "(Ancien statut) En attente",
  value: "waiting"
}];
